import type { SortingChapter } from "../sorting/chapters.ts";

/** The ten Color Lab chapters (10 levels each); same shape as the Sorting chapters. */
export type ColorChapter = SortingChapter;

const chapter = (n: number, themeId: string, name: string, focus: string, palette: readonly [string, string]): ColorChapter => ({
  chapter: n,
  themeId,
  name,
  focus,
  firstLevel: (n - 1) * 10 + 1,
  lastLevel: n * 10,
  palette,
});

/** Every chapter adds exactly one idea (docs/COLOR_LAB.md §2). */
export const COLOR_CHAPTERS: readonly ColorChapter[] = [
  chapter(1, "lab-intro", "Nhập môn", "Rót màu, đậy nút từng lọ", ["#f1e8ff", "#ffe8f1"]),
  chapter(2, "tight-shelf", "Kệ chật", "Chỉ còn một lọ trống, tính trước vài bước", ["#e6eeff", "#f3e8ff"]),
  chapter(3, "mist", "Sương mờ", "Lớp dưới bị sương che, rót tới mới lộ màu", ["#ebe6ff", "#e1efff"]),
  chapter(4, "tall-short", "Lọ cao lọ thấp", "Mỗi màu cần một lọ vừa khít", ["#fff0df", "#ffe6ef"]),
  chapter(5, "seals", "Niêm phong", "Lọ khóa chỉ mở khi màu trên con dấu xong", ["#fff4d4", "#ffe8c0"]),
  chapter(6, "shades", "Sắc độ", "Màu gần giống nhau, nhìn kỹ ký hiệu", ["#e3f6f1", "#eee8ff"]),
  chapter(7, "flask", "Bình pha", "Pha hai màu gốc thành màu mới", ["#ffedf0", "#fff5da"]),
  chapter(8, "mist-seal", "Sương và niêm phong", "Sương mờ gặp con dấu vàng", ["#e8e3ff", "#ffefda"]),
  chapter(9, "odd-flasks", "Pha trong lọ lạ", "Lọ cao thấp cùng bình pha", ["#e0f5ff", "#ffe7f3"]),
  chapter(10, "masterpiece", "Kiệt tác", "Mọi bí kíp trong một màn", ["#fff0f7", "#e7e5ff"]),
];

export function colorChapterOfLevel(levelId: number): ColorChapter {
  const found = COLOR_CHAPTERS[Math.floor((levelId - 1) / 10)];
  if (!found) throw new RangeError(`no chapter for level ${levelId}`);
  return found;
}
